import React, {useState} from 'react';
import Dialog from '@material-ui/core/Dialog';
// import Slide from '@material-ui/core/Slide';

// function Transition(props) {
//   return <Slide direction="down" {...props} />;
// }

const MyDialog = Component => ({children, ...props}) => {
  const [ data, setData ] = useState();
  return (
    <>
      <Dialog
        open={Boolean(data)}
        onClose={()=>setData(undefined)}
        // maxWidth={"lg"}
        scroll="body"
        // TransitionComponent={Transition}
      >
        <Component dados={data} {...props} />
      </Dialog>
      {React.Children.map(children, child => React.cloneElement(child, {
        modalData: data,
        modalSetData: setData
      }))}
    </>
  )
}

export default MyDialog
